import type { ComponentType } from 'react'
import type { GameModule, GameViewProps } from '@games/core'
import { fogChess, FOG_CHESS_CHAT_TAUNTS } from '@games/fog-chess'
import { FogChessGameView } from '@games/fog-chess/react'
import { FOG_CHESS_PATH } from './routes'

/* eslint-disable @typescript-eslint/no-explicit-any -- 注册表是全项目唯一需要类型擦除的地方 */
export interface GenericGameViewProps {
  readonly view: any
  /** 观战者为 null */
  readonly self: string | null
  readonly disabled: boolean
  onMove(move: any): void
}

export interface GameEntry {
  readonly id: string
  /** 玩家可访问的路由路径（必须以 / 开头）；用 `routes.ts` 的常量，不要手写字符串 */
  readonly path: string
  readonly name: string
  readonly description: string
  readonly module: GameModule<any, any, any>
  readonly View: ComponentType<GenericGameViewProps>
  /** 聊天的快捷台词；通用层只透传，不解释内容。缺省表示该游戏没有快捷台词 */
  readonly chatTaunts?: readonly string[]
}

export const GAMES: readonly GameEntry[] = [
  {
    id: fogChess.id,
    path: FOG_CHESS_PATH,
    name: fogChess.name,
    description: fogChess.description,
    module: fogChess,
    View: FogChessGameView,
    chatTaunts: FOG_CHESS_CHAT_TAUNTS,
  },
]

/** 全平台唯一注册点：新增小游戏只改这个文件 */
export function getGame(id: string): GameEntry | undefined {
  return GAMES.find((entry) => entry.id === id)
}
/* eslint-enable @typescript-eslint/no-explicit-any */

export type { GameViewProps }
